<template>
  <div class="hello">
    <div id="teste55">
      <p> testea agaeg</p>
      <p> testea agaeg</p>
      <p> testea agaeg</p>
      <p> testea agaeg</p>
      <p> testea agaeg</p>
      <p> testea agaeg</p>
      <p> testea agaeg</p>
      <p> testea agaeg</p>
      <p> testea agaeg</p>
      <p> testea agaeg</p>
      <p> testea agaeg</p>
      <p> testea agaeg</p>
      <p> testea agaeg</p>
      <p> testea agaeg</p>
      <p> testea agaeg</p>
      <p> testea agaeg</p>
      <p> testea agaeg</p>
      <p> testea agaeg</p>
      <p> testea agaeg</p>
      <p> testea agaeg</p>
      <p> testea agaeg</p>
      <p> testea agaeg</p>
      <p> testea agaeg</p>
      <p> testea agaeg</p>
      <p> testea agaeg</p>
      <p> testea agaeg</p>
      <p> testea agaeg</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  mounted(){
    $('#teste55').mCustomScrollbar({
      axis: 'y',
      theme: 'light-3',
      advanced: {
        autoExpandHorizontalScroll: true,
        updateOnContentResize: true,
        updateOnImageLoad: true,
        autoUpdateTimeout: 10,
        updateOnSelectorChange: "ul li"
      },
      live: true
    });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #teste55 {
    min-width: 260px;
    max-height: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue